import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface AvantSelectedIconProps {
  color?: Color;
}

const AvantSelectedIcon: React.FC<AvantSelectedIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M65.13 28.94C66.31 28.81 69.4501 28.48 71.0301 28.14C72.3201 27.85 72.4101 24.48 72.4101 24.48L71.52 22.57C71.52 22.57 71.5199 21.72 71.4199 20.65C71.52 20.1175 71.4944 19.569 71.3451 19.0482C71.1958 18.5273 70.9269 18.0486 70.56 17.65C70.56 17.65 63.91 12.96 63.56 12.86C62.4965 12.587 61.418 12.3767 60.33 12.23C44.22 10.47 34.71 12.04 33.33 12.49C29.9466 13.9938 26.6602 15.7071 23.49 17.62C19.36 17.51 11.43 18.95 9.70998 19.4C7.9213 19.8599 6.23982 20.6649 4.76003 21.77C3.38003 22.86 3.25999 25.94 3.46999 27.66C3.67999 29.38 4.90002 29.46 5.62002 29.57C6.34002 29.68 9.71999 29.98 9.71999 29.98L65.13 28.94Z"
      fill={color}
      stroke={color}
      strokeWidth="0.75"
    />
    <path d="M50.32 28.01L23.48 28.51" stroke="white" strokeWidth="0.75" strokeMiterlimit="10" />
    <path
      d="M63.4801 26.97C63.5474 28.1469 63.2088 29.3112 62.5211 30.2686C61.8334 31.2259 60.838 31.9184 59.7013 32.2303C58.5645 32.5422 57.355 32.4547 56.275 31.9824C55.195 31.5101 54.3097 30.6816 53.767 29.6352C53.2242 28.5888 53.0567 27.3879 53.2927 26.233C53.5287 25.078 54.1537 24.039 55.0635 23.2894C55.9732 22.5398 57.1125 22.1249 58.2912 22.1141C59.47 22.1033 60.6167 22.4972 61.54 23.23"
      fill={color}
    />
    <path
      d="M63.4801 26.97C63.5474 28.1469 63.2088 29.3112 62.5211 30.2686C61.8334 31.2259 60.8381 31.9184 59.7013 32.2303C58.5645 32.5422 57.355 32.4547 56.275 31.9824C55.195 31.5101 54.3097 30.6816 53.767 29.6352C53.2242 28.5888 53.0567 27.3879 53.2927 26.233C53.5287 25.078 54.1537 24.039 55.0635 23.2894C55.9732 22.5398 57.1125 22.1249 58.2912 22.1141C59.47 22.1033 60.6167 22.4972 61.54 23.23"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M21.8501 26.97C21.9131 28.142 21.5724 29.3001 20.8847 30.2512C20.1971 31.2023 19.204 31.8889 18.0714 32.1963C16.9387 32.5038 15.7348 32.4136 14.6606 31.9407C13.5864 31.4679 12.7069 30.641 12.1687 29.598C11.6304 28.5551 11.4661 27.3591 11.7031 26.2096C11.9401 25.0601 12.5642 24.0267 13.471 23.2816C14.3779 22.5366 15.5127 22.1251 16.6864 22.1157C17.86 22.1063 19.0013 22.4996 19.92 23.23"
      fill={color}
    />
    <path
      d="M21.8501 26.97C21.9131 28.142 21.5724 29.3001 20.8847 30.2512C20.1971 31.2023 19.204 31.8889 18.0714 32.1963C16.9387 32.5038 15.7348 32.4136 14.6606 31.9407C13.5864 31.4679 12.7069 30.641 12.1687 29.598C11.6304 28.5551 11.4661 27.3591 11.7031 26.2096C11.9401 25.0601 12.5642 24.0267 13.471 23.2816C14.3779 22.5366 15.5127 22.1251 16.6864 22.1157C17.86 22.1063 19.0013 22.4996 19.92 23.23"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M11.0901 21.36C10.4501 21.36 8.85013 21.44 8.34013 21.51C7.83013 21.58 6.67008 21.89 6.54008 22.23C6.41008 22.57 6.42008 23.35 6.54008 23.48C7.39648 23.5678 8.26086 23.5409 9.11014 23.4C9.8158 22.8376 10.4839 22.2296 11.1101 21.58C11.2301 21.49 11.2501 21.36 11.0901 21.36Z"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M25.3101 18.46C25.3101 18.46 37.1401 17.87 41.8401 17.78L65.1501 17.3"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M42.1899 12.26L40.6799 17.81"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M51.5801 12.57L54.8401 17.51"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
    <path
      d="M72.0002 18.79H67.8501C67.8138 18.7894 67.7779 18.7988 67.7465 18.8171C67.7151 18.8354 67.6893 18.8619 67.6718 18.8938C67.6543 18.9257 67.6459 18.9617 67.6474 18.998C67.6489 19.0344 67.6601 19.0696 67.6801 19.1C67.8709 19.3876 68.0814 19.6616 68.3101 19.92C68.5601 20.18 68.9701 20.73 69.4801 20.76C69.9901 20.79 71.4102 20.76 71.4102 20.76H71.9301"
      stroke="white"
      strokeWidth="0.75"
      strokeMiterlimit="10"
    />
  </svg>
);

export default AvantSelectedIcon;
